<template>
  <step-wizard v-model="step" :can-go-back="!anySent && !busy">
    <wizard-step name="mode" title="Выбор типа движения">
      <mode-step></mode-step>
    </wizard-step>

    <wizard-step name="entry" :title="entryTitle">
      <entry-step @saved="$emit('saved')" @cancel="$emit('cancel')"></entry-step>
    </wizard-step>

    <!-- Поступление: этап полей появляется, только когда нажали кнопку дальнейшего действия -->
    <wizard-step v-if="isIncoming && action" name="details" :title="detailsTitle">
      <details-step @saved="$emit('saved')" @cancel="$emit('cancel')"></details-step>
    </wizard-step>
  </step-wizard>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import StepWizard from "@/components/ecologist/dataEntryNew/stepWizard";
import WizardStep from "@/components/ecologist/dataEntryNew/wizardStep";
import ModeStep from "@/components/ecologist/dataEntryNew/modeStep";
import EntryStep from "@/components/ecologist/dataEntryNew/entryStep";
import DetailsStep from "@/components/ecologist/dataEntryNew/detailsStep";

/*
  Внесение данных по отходу: режим → даты с количеством (у расхода - и с полями режима)
  → у поступления поля дальнейшего действия. Состояние - в модуле стора wasteEntry
*/
export default {
  name: "wasteEntry",
  components: { StepWizard, WizardStep, ModeStep, EntryStep, DetailsStep },
  props: {
    // Узел отхода из дерева: techProcessHasWasteId, organizationWasteId, unitId, name
    waste: { type: Object, required: true },
  },

  computed: {
    ...mapState("wasteEntry", ["action", "busy"]),
    ...mapGetters("wasteEntry", [
      "isIncoming",
      "anySent",
      "entryTitle",
      "detailsTitle",
      // Есть что терять при переключении на другой элемент дерева
      "isDirty",
    ]),
    step: {
      get() {
        return this.$store.state.wasteEntry.step;
      },
      set(step) {
        this.$store.commit("wasteEntry/setStep", step);
      },
    },
    firstDate() {
      return this.$store.state.wasteEntry.dates[0];
    },
  },

  watch: {
    // Контрагенты передачи - с договором, действующим на первую дату. Даты меняются на обоих экранах
    firstDate() {
      this.$store
        .dispatch("wasteEntry/reloadOptions")
        .catch(() => this.$message.error("Не удалось загрузить справочники"));
    },
  },

  created() {
    this.$store.dispatch("wasteEntry/start", this.waste);
  },

  async mounted() {
    try {
      await this.$store.dispatch("wasteEntry/loadPage");
    } catch (error) {
      this.$message.error("Не удалось загрузить данные отхода");
    }
  },
};
</script>
